import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import { FunctionComponent } from 'react'
import { ArticlePreview } from './ArticlePreview'
import { MediaFilePreview } from './MediaFilePreview'
import { FolderPreview } from './FolderPreview'
import { DesignPreview } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/DesignPreview'

type PreviewableFileType = 'folder' | 'article' | 'media_file' | 'design'

const FilePreviews: Record<PreviewableFileType, FunctionComponent<FilePreviewProps>> = {
  article: ArticlePreview,
  media_file: MediaFilePreview,
  folder: FolderPreview,
  design: DesignPreview,
}

export const FilePreview = ({ file, className, emptyClassName }: FilePreviewProps) => {
  const PreviewComponent = FilePreviews[file.type as PreviewableFileType]

  if (!PreviewComponent) return null

  return <PreviewComponent file={file} className={className} emptyClassName={emptyClassName} />
}
